import { render, staticRenderFns } from "./JSelectGroup.vue?vue&type=template&id=65dce078&scoped=true&"
import script from "./JSelectGroup.vue?vue&type=script&lang=js&"
export * from "./JSelectGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dce078",
  null
  
)

export default component.exports